// Payment provider codes
export const PAYMENT_PROVIDERS = {
  MERCADO_PAGO: 'mercadopago',
  BANK: 'bank',
  TRANSFER: 'transfer',
  REBILL: 'rebill',
  REBILL_US: 'rebill-us',
};

// Payment provider display information
export const PAYMENT_PROVIDER_INFO = {
  [PAYMENT_PROVIDERS.MERCADO_PAGO]: {
    name: 'Mercado Pago',
    code: PAYMENT_PROVIDERS.MERCADO_PAGO,
  },
  [PAYMENT_PROVIDERS.BANK]: {
    name: 'Depósito bancario o Efectivo',
    code: PAYMENT_PROVIDERS.BANK,
  },
  [PAYMENT_PROVIDERS.TRANSFER]: {
    name: 'Transferencia bancaria',
    code: PAYMENT_PROVIDERS.TRANSFER,
  },
  [PAYMENT_PROVIDERS.REBILL]: {
    name: 'Rebill',
    code: PAYMENT_PROVIDERS.REBILL,
  },
  [PAYMENT_PROVIDERS.REBILL_US]: {
    name: 'Rebill US',
    code: PAYMENT_PROVIDERS.REBILL_US,
  },
};
